import { Body, Controller, Post } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import { DepartmentService } from "./department.service";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { CommonResponseModel } from "@project-management-system/shared-models";
import { DepartmentDto } from "./departments.dto";


@Controller('department')
@ApiTags('/department')
export class DepartmentController {
    constructor(private service: DepartmentService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) { }

    @Post('/getAllDepartments')
    async getAllDepartments(): Promise<CommonResponseModel> {
        try {
            return await this.service.getAllDepartments();
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/createDepartment')
    @ApiBody({ type: DepartmentDto })
    async createDepartment(@Body() req: any): Promise<CommonResponseModel> {
        try {
            console.log(req, 'ppppppppppp');

            return await this.service.createDepartment(req);
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }

    }

    @Post('/getActiveAllDepartments')
    async getActiveAllDepartments(): Promise<CommonResponseModel> {
        try {
            return await this.service.getActiveAllDepartments();
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/updateDepartment')
    @ApiBody({ type: DepartmentDto })
    async updateDepartment(@Body() req: any): Promise<CommonResponseModel> {
        try {


            return await this.service.updateDepartment(req);
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/activateOrDeactivateDepartment')
    @ApiBody({ type: DepartmentDto })
    async activateOrDeactivateDepartment(@Body() dto: any, isUpdate: boolean = false): Promise<CommonResponseModel> {
        try {
            return await this.service.activateOrDeactivateDepartment(dto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

}